import { useCallback, useState } from 'react';
import { KpisResponse, KpiQueryParams, ESnackbarStyle } from 'shared/types';
import { getKpis } from 'services/api/dashboardService';
import { openNotification } from 'utils/notification-utils';

interface UseDashboardKpisResult {
  kpis: KpisResponse | null;
  isLoading: boolean;
  error: string | null;
  fetchKpis: (params?: KpiQueryParams) => Promise<void>;
}

const useDashboardKpis = (): UseDashboardKpisResult => {
  const [kpis, setKpis] = useState<KpisResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchKpis = useCallback(async (params?: KpiQueryParams): Promise<void> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getKpis(params);
      setKpis(response.data);
    } catch (e: any) {
      const errorMessage = e.message || 'Failed to fetch KPIs';
      setError(errorMessage);
      openNotification(ESnackbarStyle.ERROR, errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    kpis,
    isLoading,
    error,
    fetchKpis
  };
};

export default useDashboardKpis;
